import { gql } from '@apollo/client';

export const JOB_FIELDS = gql`
  fragment JobFields on Job {
    jobId
    title
    description
    employmentType
    salary
    level
  }
`;
